/* if adding a new flag, update use-record-all-flags.ts */

"use client";

import { usePostHogFlag } from "../use-posthog-flag";

export function useEmbeddedWalletsEnabled() {
  return usePostHogFlag("enable_turnkey");
}
